<template lang="pug">
div.avatar
  img(v-if="src" :src="src" alt="avatar")
  div.placeholder(v-else)
    v-icon(class="mdi mdi-account" small)

</template>

<script>
export default {
  name: 'PersonAvatar',
  props: {
    src: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.placeholder {
  background: #fff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.placeholder i {
  color: #bbb;
  font-size: 36px;
}
</style>
